import {
  Card,
  CardContent,
  Skeleton,
  Box,
} from '@mui/material';
import React from 'react';

function SkeletonCard({ 
  height = 200, 
  hasAvatar = false, 
  lines = 3,
  actions = false,
  ...props 
}) {
  return (
    <Card {...props}>
      <CardContent>
        {hasAvatar && (
          <Box display="flex" alignItems="center" mb={2}>
            <Skeleton variant="circular" width={40} height={40} />
            <Box ml={2} flex={1}>
              <Skeleton variant="text" width="60%" />
              <Skeleton variant="text" width="40%" />
            </Box>
          </Box>
        )}
        
        {Array.from({ length: lines }).map((_, index) => (
          <Skeleton
            key={index}
            variant="text"
            width={index === lines - 1 ? '70%' : '100%'}
            sx={{ mb: 1 }}
          />
        ))}
        
        <Skeleton variant="rectangular" width="100%" height={height - 120} sx={{ mt: 2 }} />
        
        {actions && (
          <Box display="flex" justifyContent="space-between" mt={2}>
            <Skeleton variant="rectangular" width={80} height={36} />
            <Skeleton variant="rectangular" width={80} height={36} />
          </Box>
        )}
      </CardContent>
    </Card>
  );
}

export default SkeletonCard;